module.exports = __webpack_public_path__ + "static/media/start.17934d91.svg";